
import classNames from 'classnames';
import React from 'react';
import Spinner from './Spinner';
const styles = require('./LoadingIndicator-styles.module.scss');
export default function LoadingIndicator({
  className
}) {
  return React.createElement("div", {
    className: classNames(className, styles.container)
  }, React.createElement(Spinner, {
    size: "lg"
  }));
}